import { isEmojiCharacter, validatePhoneOrTel } from '@/utils/validate'

export const needLicenseTypeList = [
  { label: '身份证', value: 10, disabled: true },
  { label: '驾驶证', value: 20, disabled: true },
  { label: '网约车驾驶员资格证', value: 40, disabled: false },
]
export const detailDataConfig = () => {
  const storeInfo_formConfig = [
    {
      name: '门店名称',
      key: 'name',
    },
    {
      name: '联系电话',
      key: 'contactTel',
    },
    {
      name: '所在城市',
      key: 'provinceCity',
    },
    {
      name: '营业时间',
      key: 'businessHours',
    },
    {
      name: '详细地址',
      key: 'address',
      alone: true,
    },
  ]
  const storeService_formConfig = [
    {
      name: '司机签约提车所需证件',
      key: 'needLicenseType',
      formatter: (value) => {
        const result = value.reduce((arr, item) => {
          const hasItem = needLicenseTypeList.find((typeItem) => typeItem.value === item)
          if (hasItem) {
            arr.push(hasItem.label)
          }
          return arr
        }, [])
        return result.join('、')
      },
      alone: true,
    },
  ]
  const storeInfo_model = {
    name: '',
    contactTel: '',
    provinceCode: '',
    cityCode: '',
    address: '',
    needLicenseType: [],
  }
  return {
    storeInfo_formConfig,
    storeService_formConfig,
    storeInfo_model,
  }
}

function validNameLength(rule, value, callback) {
  if (value.length > 20) {
    callback(new Error('内容长度为20'))
  } else if (isEmojiCharacter(value)) {
    callback(new Error('不允许输入表情'))
  } else {
    callback()
  }
}

export const storeInfoFormRule = {
  name: [
    { required: true, message: '请输入门店名称', trigger: 'blur' },
    { required: true, validator: validNameLength, trigger: 'blur' },
  ],
  contactTel: [
    { required: true, message: '请输入联系电话', trigger: 'blur' },
    { required: true, validator: validatePhoneOrTel, trigger: 'blur' },
  ],
  provinceCode: [
    { required: true, message: '请选择省份', trigger: 'change' },
  ],
  cityCode: [
    { required: true, message: '请选择所在城市', trigger: 'change' },
  ],
  address: [
    { required: true, message: '请填写门店地址', trigger: 'change' },
  ],
  businessHours: [
    { required: true, message: '请选择营业时间', trigger: 'change' },
  ],
  needLicenseType: [
    { required: true, message: '请选择所需证件', trigger: 'change' },
  ],
}
